var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2027_119649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8654 5.28137H10.1261C9.86724 5.28137 9.65736 5.49125 9.65736 5.75014C9.65736 6.00903 9.86724 6.21891 10.1261 6.21891H13.2462L9.77735 17.7818H6.37599C6.1171 17.7818 5.90723 17.9917 5.90723 18.2506C5.90723 18.5095 6.1171 18.7194 6.37599 18.7194H10.1156C10.1228 18.7195 10.1299 18.7195 10.137 18.7194H13.8763C14.1352 18.7194 14.345 18.5095 14.345 18.2506C14.345 17.9917 14.1352 17.7818 13.8763 17.7818H10.7562L14.225 6.21891H17.6264C17.8853 6.21891 18.0952 6.00903 18.0952 5.75014C18.0952 5.49125 17.8853 5.28137 17.6264 5.28137H13.8868C13.8796 5.28121 13.8725 5.28121 13.8654 5.28137Z",
    fill: "#808080",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2027_119649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0006,
    height: 15.0006,
    fill: "white",
    transform: "translate(4.50098 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalize);
export default __webpack_public_path__ + "static/media/italize.d1cfadad1f68d2fa1e5a9175e8e80a3e.svg";
export { ForwardRef as ReactComponent };